var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 138,
    viewBox: "0 0 41 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-142.116 108.264C-157.666 96.1099 -168.265 80.0766 -173.672 62.6642C-174.422 60.2517 -176.568 58.5347 -179.099 58.4012L-179.25 58.3927C-183.673 58.1584 -186.831 62.6405 -185.067 66.6913C-177.834 83.2959 -166.631 98.4763 -151.598 110.725C-101.984 151.15 -28.3741 144.33 12.7821 95.4711C43.7857 58.6602 48.1283 8.5608 28.132 -31.8243C22.5462 -43.1041 7.65434 -45.9085 -1.78552 -37.5829C-8.81017 -31.3879 -10.2381 -21.0827 -5.34288 -13.0951C14.9798 20.0572 12.9613 63.8345 -13.7132 95.2574C-45.8656 133.126 -102.903 138.908 -142.116 108.264Z",
    fill: "#E83871"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopbg);
export default __webpack_public_path__ + "static/media/topbg.04921b281ffba4c09f48fff5ffcbf9ce.svg";
export { ForwardRef as ReactComponent };